import client from './client';

export const getOverview = (params) => client.get('/dashboard/overview', { params });
